import { render } from "./AppTablePagination.vue?vue&type=template&id=db2a214c&scoped=true&ts=true"
import script from "./AppTablePagination.vue?vue&type=script&lang=ts"
export * from "./AppTablePagination.vue?vue&type=script&lang=ts"

import "./AppTablePagination.vue?vue&type=style&index=0&id=db2a214c&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\TTI.AVE.Web\\Vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db2a214c"]])

export default __exports__